/**
 * O contrato entre a casca da Configurações e a tela embutida — K-4.
 *
 * Mora fora do `.tsx` porque contexto e hook convivendo com componente quebram o
 * fast refresh (o lint acusa, e com razão — o arquivo passaria a ter dois
 * motivos para recarregar). Mesma separação que o K-1 fez em `secoes.ts`.
 *
 * O Provider está em `casca-contexto.tsx`.
 */
import { createContext, useContext, type ReactNode } from 'react';

interface CascaValor {
  /** `true` quando o componente está sendo renderizado dentro da casca. */
  dentroDaCasca: boolean;
  /** As ações que a tela filha declarou, para o cabeçalho desenhar. */
  acoes: ReactNode;
  /** A tela filha publica (ou limpa) sua ação principal. */
  publicarAcoes: (a: ReactNode) => void;
}

export const Ctx = createContext<CascaValor>({
  dentroDaCasca: false,
  acoes: null,
  publicarAcoes: () => {},
});

/**
 * Fora da casca devolve `dentroDaCasca: false` — é o default do contexto.
 *
 * Isso importa: as mesmas telas ainda são alcançáveis por outras rotas enquanto
 * o K-3 não termina, e nesses lugares elas precisam continuar desenhando o
 * próprio cabeçalho.
 */
export function useCasca(): CascaValor {
  return useContext(Ctx);
}
